import React from "react";
import { Navigate } from "react-router-dom";
import { Box, Skeleton } from "@mui/material";
import { useEffectivePermissions, toSet, can } from "../../hooks/useEffectivePermissions";

function PermissionLoadingSkeleton() {
  return (
    <Box sx={{ p: 3, display: "flex", flexDirection: "column", gap: 2 }}>
      <Skeleton variant="text" width={180} height={32} />
      <Skeleton variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
      <Skeleton variant="rectangular" height={240} sx={{ borderRadius: 1 }} />
    </Box>
  );
}

export default function Require({ resource, action = "view", children, fallback = null, redirect = "/chat" }) {
  const { data, isLoading, error } = useEffectivePermissions();

  if (isLoading) {
    return fallback ?? <PermissionLoadingSkeleton />;
  }

  if (error) return <div style={{ padding: 16 }}>Falha ao validar permissões.</div>;

  const set = toSet(data?.scopes);
  return can(set, resource, action) ? children : <Navigate to={redirect} replace />;
}
